module.exports = __webpack_public_path__ + "fonts/intelo-italic.2764949.woff2";